<script>
  export let href = '#';
</script>

<a href={href} target="_blank" rel="nofollow noreferrer noopener">
  <slot />
</a>
